import {HashRouter as Router, Route, Redirect, Switch} from 'react-router-dom';
import React, {Suspense} from 'react';
import {I18nextProvider} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Font} from '@wealth-common/font';
import Loading from 'components/Load';

import i18n from './i18n';
// import Header from './components/Header';
import routes from './routes.config';

const Routing = () => {
  const appResult = useSelector((state) => state.app);
  console.log('appResult.apiInflight=====', appResult.apiInflight);
  const SuspenseLoading = <Loading showing={true} />;
  return (
    <I18nextProvider i18n={i18n}>
      <Font />
      {/* <Header history={history} /> */}
      <Router>
        <Suspense fallback={SuspenseLoading}>
          {appResult.apiInflight > 0 ? (
            <Loading showing={true} showText={appResult.showLoadingText} />
          ) : null}
          <Switch>
            {routes.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        </Suspense>
      </Router>
    </I18nextProvider>
  );
};

const allowRedirect = (props) => props.match.url === props.location.pathname;

const RouteWithSubRoutes = (route) => (
  <Route
    exact={route.exact}
    mode={history}
    path={route.path}
    params={route.params}
    render={(props) => {
      return route.redirect && allowRedirect(props) ? (
        <Redirect to={route.redirect} />
      ) : (
        <route.component {...props} routes={route.routes} />
      );
    }}
  />
);

export {Routing, RouteWithSubRoutes};
